export const API_END_POINTS = {
    GET_FILTER: '/api/v1/slot/get-filter',
    GET_TEMPLATE: '/api/v1/slot/get-slot-config-day-template',
    GET_LIVE_SLOT:'/api/v1/slot/get-slot-config-day-live',
    GET_REGIONS:'/api/v1/slot/get-regions',
    ADD_SLOTS:'/api/v1/slot/v2-save-slot-config',   
    SAVE_LIVE_SLOTS:'/api/v1/slot/save-slot-config-day-live',
    GET_SLOT_CONFIGURATION:'/api/v1/slot/get-slot-list',
    ADD_SLOT_CONFIGURATION:'/api/v1/slot/vehicle-add-slot',
    REMOVE_SLOT_CONFIGURATION:'/api/v1/slot/vehicle-remove-slot',
    LOGIN_SERVICE:'/api/v1/auth/login',
    GET_MODULES_BY_ROLE:'/api/v1/role/module'
}
